<template>
  <component
    v-bind="$attrs"
    :is="href === '#' ? 'button' : 'InertiaLink'"
    class="tw-group tw-relative tw-rounded-full tw-p-2 tw-transition-colors hover:tw-bg-neutral-50 hover:tw-text-current"
    :href="href"
  >
    <div
      v-if="hasRedIndicator"
      class="tw-absolute tw-rounded-full tw-border-2 tw-border-white tw-bg-error-500 tw-text-white tw-transition-colors group-hover:tw-border-neutral-50"
      :class="[
        indicatorValue
          ? 'tw-right-0 tw-top-0 tw-inline-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center'
          : 'tw-right-1 tw-top-1 tw-h-3 tw-w-3',
        indicatorValue > 99 ? 'tw-text-[8px]' : 'tw-text-[10px]',
      ]"
    >
      {{ isIndicatorValueSet ? formattedIndicatorValue : '' }}
    </div>
    <span class="tw-sr-only">{{ screenReaderText }}</span>
    <slot />
  </component>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  hasRedIndicator: {
    type: Boolean,
    default: false,
  },
  indicatorValue: {
    type: Number,
    default: 0,
  },
  screenReaderText: {
    type: String,
    required: true,
  },
  href: {
    type: String,
    default: '#',
  },
})

const isIndicatorValueSet = computed(() => props.indicatorValue > 0)
const formattedIndicatorValue = computed(() =>
  props.indicatorValue > 99 ? '99+' : props.indicatorValue,
)
</script>
